module.exports = __webpack_public_path__ + "static/img/YouTube.af5a5f83.png";